"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.username = /[a-z][\w-]{0,28}[a-z0-9]/i;
//# sourceMappingURL=regexes.js.map